import { MouseEvent, SetStateAction, Dispatch } from 'react'
import { ToggleButtonGroup, ToggleButton } from '@mui/material'

type ToggleActiveButtons = {
  isActive: boolean,
  setIsActive: Dispatch<SetStateAction<boolean>>,
}

const ToggleActiveButtons = (props: ToggleActiveButtons) => {
  const { isActive, setIsActive } = props

  const handleIsActive = (event: MouseEvent<HTMLElement>, value: boolean) => {
    if (value !== null) setIsActive(value)
  }

  const buttonStyles = { paddingLeft: '16px', paddingRight: '16px' }

  return (
    <ToggleButtonGroup
      size="small"
      color="primary"
      value={isActive}
      exclusive
      onChange={handleIsActive}
    >
      <ToggleButton value={true} sx={buttonStyles}>
        Active
      </ToggleButton>
      <ToggleButton value={false} sx={buttonStyles}>
        Inactive
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default ToggleActiveButtons
